import type { Router } from 'vue-router';

type RouterReference = {
  router: Router | null;
};
export const globalRouterReference: RouterReference = { router: null };
